import { useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useTheme } from 'styled-components';
import Loader from '../components/Loader';
import {
  Section,
  SectionItem,
  SectionLink,
  SectionName,
} from '../components/Chrome';
import {
  Drawer,
  DrawerExit,
  DrawerLink,
  DrawerList,
  DrawerTrigger,
} from '../components/Drawer';
import Icon from '../components/Icon';
import LeaveSpaceModal from '../modals/LeaveSpace';
import { VIEWER } from '../utilities/queries';
import { getRelativeTime } from '../utilities/getRelativeTime';

const SettingsSpacesPage = () => {
  const theme = useTheme();
  const { loading, data } = useQuery(VIEWER);

  const [isLeaveSpaceModalOpen, setIsLeaveSpaceModalOpen] = useState(false);

  // Used to pass space data to action modals
  const [space, setSpace] = useState();

  // Tracks the space user the viewer is interacting with
  const listRef = useRef();
  const [trackSpace, setTrackSpace] = useState();

  return (
    <>
      <Section>
        {loading ? (
          <Loader />
        ) : (
          <>
            <Helmet>
              <title>Spaces</title>
            </Helmet>
            <SectionName isSecondLevel>Spaces</SectionName>
            {data?.viewer.spaces.length !== 0 ? (
              data.viewer.spaces.map((space) => (
                <Drawer key={space.id} onClose={() => setTrackSpace(null)}>
                  <DrawerTrigger onClick={() => setTrackSpace(space.id)}>
                    <SectionLink as="button" isActive={trackSpace === space.id}>
                      <span>{space.name}</span>
                      <span
                        style={{ display: 'flex', gridGap: theme.space[3] }}
                      >
                        {space.joinedAt &&
                          `(${getRelativeTime(space.joinedAt)})`}{' '}
                        <Icon name="more" />
                      </span>
                    </SectionLink>
                  </DrawerTrigger>
                  <DrawerList ref={listRef}>
                    <DrawerExit />
                    <DrawerLink to={`/s/${space.slug}`}>View space</DrawerLink>
                    {data.viewer.id !== space.ownerId && (
                      <DrawerLink
                        as="button"
                        onClick={() => {
                          setSpace(space);
                          setIsLeaveSpaceModalOpen(true);
                        }}
                        dontRunOnClose
                      >
                        Leave space
                      </DrawerLink>
                    )}
                  </DrawerList>
                </Drawer>
              ))
            ) : (
              <SectionItem>You aren't in any spaces.</SectionItem>
            )}
          </>
        )}
      </Section>
      {isLeaveSpaceModalOpen && (
        <LeaveSpaceModal
          space={space}
          onClose={() => {
            setTrackSpace(null);
            setIsLeaveSpaceModalOpen(false);
          }}
        />
      )}
      <Outlet />
    </>
  );
};

export default SettingsSpacesPage;
